(() => {
  const strings = window.escentielStrings || {};
  const tr = (key, fallback) => strings[key] || fallback;
  const locale = strings.locale || document.documentElement.lang || 'fr';
  const rootPath = window.Shopify?.routes?.root || '/';
  const menu = document.querySelector('[data-theme-menu]');
  const menuBackdrop = document.querySelector('.menu-backdrop');
  const menuTrigger = document.querySelector('[data-theme-menu-open]');
  let menuReturnFocus = null;
  const openMenu = () => {
    menuReturnFocus = document.activeElement;
    menu?.classList.add('is-open');
    menu?.setAttribute('aria-hidden', 'false');
    menuBackdrop?.classList.add('is-open');
    menuTrigger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('is-locked');
    window.requestAnimationFrame(() => menu?.querySelector('button[data-theme-menu-close]')?.focus());
  };
  const closeMenu = () => {
    const wasOpen = menu?.classList.contains('is-open');
    menu?.classList.remove('is-open');
    menu?.setAttribute('aria-hidden', 'true');
    menuBackdrop?.classList.remove('is-open');
    menuTrigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('is-locked');
    if (wasOpen && menuReturnFocus instanceof HTMLElement) menuReturnFocus.focus();
  };
  menuTrigger?.addEventListener('click', openMenu);
  document.querySelectorAll('[data-theme-menu-close]').forEach(button => button.addEventListener('click', closeMenu));
  menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });

  const revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }), { threshold: 0.08 });
    revealItems.forEach(item => revealObserver.observe(item));
  } else {
    revealItems.forEach(item => item.classList.add('is-visible'));
  }

  const homeHero = document.querySelector('[data-home-hero]');
  const homeHeroImage = homeHero?.querySelector('[data-home-hero-image]');
  if (homeHero && homeHeroImage) {
    let heroVisuals = [];
    try { heroVisuals = JSON.parse(homeHero.dataset.heroImages || '[]'); } catch {}
    if (heroVisuals.length) {
      const previousHero = Number.parseInt(sessionStorage.getItem('escentiel-last-hero') || '-1', 10);
      const availableHeroes = heroVisuals.map((_, index) => index).filter(index => index !== previousHero);
      let selectedHero = availableHeroes[Math.floor(Math.random() * availableHeroes.length)] ?? 0;
      homeHeroImage.src = heroVisuals[selectedHero];
      homeHero.dataset.heroIndex = String(selectedHero + 1);
      sessionStorage.setItem('escentiel-last-hero', String(selectedHero));
      heroVisuals.forEach(source => { const preload = new Image(); preload.src = source; });
      requestAnimationFrame(() => homeHero.classList.add('is-copy-visible'));
      const revealImage = () => window.setTimeout(() => homeHero.classList.add('is-image-visible'), 460);
      if (homeHeroImage.decode) homeHeroImage.decode().then(revealImage).catch(revealImage);
      else if (homeHeroImage.complete) revealImage();
      else homeHeroImage.addEventListener('load', revealImage, { once: true });
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.setInterval(() => {
          homeHero.classList.add('is-switching');
          window.setTimeout(() => {
            selectedHero = (selectedHero + 1) % heroVisuals.length;
            homeHeroImage.src = heroVisuals[selectedHero];
            homeHero.dataset.heroIndex = String(selectedHero + 1);
            sessionStorage.setItem('escentiel-last-hero', String(selectedHero));
            const revealNext = () => homeHero.classList.remove('is-switching');
            if (homeHeroImage.decode) homeHeroImage.decode().then(revealNext).catch(revealNext);
            else homeHeroImage.addEventListener('load', revealNext, { once: true });
          }, 420);
        }, 7000);
      }
    }
  }

  const essentials = document.querySelector('.home-essentials--four');
  if (essentials && !essentials.querySelector('.home-essentials__track')) {
    const items = [...essentials.children].filter(element => element.matches('article'));
    if (items.length) {
      const track = document.createElement('div');
      track.className = 'home-essentials__track';
      items.forEach(item => track.append(item));
      items.forEach(item => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.append(clone);
      });
      essentials.append(track);
      essentials.classList.add('is-marquee');
    }
  }

  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    const track = carousel.querySelector('.horizontal-carousel__track');
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!track || (!previous && !next)) return;

    const getStep = () => {
      const firstCard = track.firstElementChild;
      if (!firstCard) return Math.max(track.clientWidth * 0.82, 240);
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };
    const getMaxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const move = direction => {
      const maxScroll = getMaxScroll();
      const target = Math.max(0, Math.min(maxScroll, track.scrollLeft + direction * getStep()));
      track.scrollTo({ left: target, behavior: 'smooth' });
    };
    const syncState = () => {
      const maxScroll = getMaxScroll();
      carousel.classList.toggle('is-scrollable', maxScroll > 1);
      previous?.toggleAttribute('data-at-start', track.scrollLeft <= 1);
      next?.toggleAttribute('data-at-end', track.scrollLeft >= maxScroll - 1);
    };
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', syncState, { passive: true });
    window.addEventListener('resize', syncState, { passive: true });
    window.addEventListener('pageshow', () => {
      track.scrollLeft = 0;
      syncState();
    }, { once: true });
    syncState();
  });

  const heroVideo = document.querySelector('[data-hero-video], .theme-home-hero__video');
  if (heroVideo) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const syncHeroVideo = () => {
      if (reducedMotion.matches) {
        heroVideo.pause();
        heroVideo.currentTime = 0;
        return;
      }
      heroVideo.play().catch(() => {});
    };
    syncHeroVideo();
    reducedMotion.addEventListener?.('change', syncHeroVideo);
  }

  document.querySelectorAll('.product-gallery').forEach(gallery => {
    const slides = [...gallery.children].filter(element => element.matches('img'));
    if (slides.length < 2) return;
    gallery.classList.add('is-carousel');
    gallery.setAttribute('role', 'region');
    gallery.setAttribute('aria-roledescription', 'carousel');
    gallery.setAttribute('aria-label', tr('galleryChoose', 'Choisir une photo'));
    const track = document.createElement('div');
    track.className = 'product-gallery__track';
    slides.forEach((slide, index) => {
      slide.setAttribute('draggable', 'false');
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-roledescription', 'diapositive');
      slide.setAttribute('aria-label', `${index + 1} sur ${slides.length}`);
      if (slide.hasAttribute('data-recharge-image')) slide.classList.add('is-product-cutout');
      track.append(slide);
    });
    gallery.append(track);
    const previous = document.createElement('button');
    previous.className = 'product-gallery__arrow product-gallery__arrow--previous';
    previous.type = 'button'; previous.setAttribute('aria-label', tr('galleryPrevious', 'Photo précédente')); previous.textContent = '<';
    const next = document.createElement('button');
    next.className = 'product-gallery__arrow product-gallery__arrow--next';
    next.type = 'button'; next.setAttribute('aria-label', tr('galleryNext', 'Photo suivante')); next.textContent = '>';
    const status = document.createElement('span');
    status.className = 'product-gallery__status'; status.setAttribute('aria-live', 'polite');
    gallery.append(previous, next, status);
    const thumbnails = document.createElement('div');
    thumbnails.className = 'product-gallery__thumbnails';
    thumbnails.setAttribute('aria-label', tr('galleryChoose', 'Choisir une photo'));
    const thumbnailButtons = slides.map((slide, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-gallery__thumbnail';
      button.setAttribute('aria-label', `${tr('galleryShow', 'Afficher la photo')} ${index + 1}`);
      const thumbnail = slide.cloneNode(false);
      thumbnail.removeAttribute('role');
      thumbnail.removeAttribute('aria-label');
      thumbnail.removeAttribute('aria-hidden');
      thumbnail.alt = '';
      button.append(thumbnail);
      button.addEventListener('click', () => show(index));
      thumbnails.append(button);
      return button;
    });
    gallery.after(thumbnails);
    let current = 0;
    let pointerStart = 0;
    let pointerDelta = 0;
    const show = index => {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translate3d(${-current * 100}%,0,0)`;
      slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', slideIndex === current ? 'false' : 'true'));
      thumbnailButtons.forEach((button, buttonIndex) => {
        button.classList.toggle('is-active', buttonIndex === current);
        button.setAttribute('aria-current', buttonIndex === current ? 'true' : 'false');
      });
      status.textContent = `${String(current + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    };
    previous.addEventListener('click', () => show(current - 1));
    next.addEventListener('click', () => show(current + 1));
    gallery.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
    });
    gallery.tabIndex = 0;
    gallery.addEventListener('pointerdown', event => {
      if (event.target.closest('button')) return;
      pointerStart = event.clientX; pointerDelta = 0;
      gallery.classList.add('is-dragging'); gallery.setPointerCapture?.(event.pointerId);
    });
    gallery.addEventListener('pointermove', event => {
      if (!gallery.classList.contains('is-dragging')) return;
      pointerDelta = event.clientX - pointerStart;
      track.style.transform = `translate3d(calc(${-current * 100}% + ${pointerDelta}px),0,0)`;
    });
    const finishDrag = event => {
      if (!gallery.classList.contains('is-dragging')) return;
      gallery.classList.remove('is-dragging'); gallery.releasePointerCapture?.(event.pointerId);
      if (Math.abs(pointerDelta) > Math.min(90, gallery.clientWidth * .15)) show(current + (pointerDelta < 0 ? 1 : -1));
      else show(current);
    };
    gallery.addEventListener('pointerup', finishDrag);
    gallery.addEventListener('pointercancel', finishDrag);
    show(0);
  });

  const setupQuizStepper = form => {
    if (!form) return null;
    const panels = [...form.querySelectorAll('fieldset')];
    const progress = form.querySelector('[data-quiz-progress]');
    const currentLabel = form.querySelector('[data-quiz-current]');
    const back = form.querySelector('[data-quiz-back]');
    let current = 0;
    const show = index => {
      current = Math.max(0, Math.min(index, panels.length - 1));
      panels.forEach((panel, panelIndex) => {
        const active = panelIndex === current;
        panel.classList.toggle('is-current', active);
        panel.setAttribute('aria-hidden', String(!active));
      });
      if (progress) progress.style.width = `${((current + 1) / panels.length) * 100}%`;
      if (currentLabel) currentLabel.textContent = String(current + 1).padStart(2, '0');
      if (back) back.disabled = current === 0;
      form.classList.toggle('is-last', current === panels.length - 1);
    };
    panels.forEach((panel, panelIndex) => panel.querySelectorAll("input[type='radio']").forEach(input => input.addEventListener('change', () => {
      if (panelIndex < panels.length - 1) window.setTimeout(() => show(panelIndex + 1), 180);
    })));
    back?.addEventListener('click', () => show(current - 1));
    show(0);
    return { reset: () => show(0) };
  };

  const fragranceQuiz = document.querySelector('[data-fragrance-quiz]');
  const fragranceForm = fragranceQuiz?.querySelector('form');
  const fragranceResult = fragranceQuiz?.querySelector('[data-quiz-result]');
  const fragranceStepper = setupQuizStepper(fragranceForm);
  // Product profiles verified against Shopify refill descriptions on 2026-08-28.
  // Keep this block identical in theme.js and pages.js (checked by quiz tests).
  const fragranceRecommendations = {
    fraiche: { name: 'Volute de Thé', handle: 'subteal', family: 'hesperidee', intensity: 'subtile', fr: 'Hespéridée · Subtile. Lumineuse, apaisante et délicate.', en: 'Citrus · Subtle. Luminous, soothing and delicate.' },
    douce: { name: 'Éclat de Nerola', handle: 'ambre-clair', family: 'florale', intensity: 'subtile', fr: 'Florale · Subtile. Fraîche, pure et enveloppante.', en: 'Floral · Subtle. Fresh, pure and enveloping.' },
    chaleureuse: { name: 'Aura Dorée', handle: 'ladoree', family: 'ambree', intensity: 'intense', fr: 'Ambrée · Intense. Chaleureuse, enveloppante et addictive.', en: 'Amber · Intense. Warm, enveloping and addictive.' },
    elegante: { name: 'Ombre Blanche', handle: 'ombre-blanche', family: 'chypree', intensity: 'equilibree', fr: 'Chyprée · Équilibrée. Élégante, feutrée et sophistiquée.', en: 'Chypre · Balanced. Elegant, soft and sophisticated.' },
    vibrante: { name: 'Pourpre 15.21', handle: 'second-sens', family: 'fruitee', intensity: 'intense', fr: 'Fruitée · Intense. Vibrante, audacieuse et captivante.', en: 'Fruity · Intense. Vibrant, bold and captivating.' }
  };
  const fragrancePresence = { subtile: 0, equilibree: 1, intense: 2 };
  const recommendFragrance = values => {
    if (!Object.hasOwn(fragranceRecommendations, values.impression)
      || !Object.values(fragranceRecommendations).some(item => item.family === values.family)
      || !Object.hasOwn(fragrancePresence, values.intensity)) return null;
    // Impression and family each earn 4 points. Presence earns 0–2 points
    // according to distance from the product profile. It can resolve a conflict,
    // never replace two concordant preferences with an unrelated fragrance.
    // A remaining tie favours the owner's explicit question-1 correspondence.
    const ranked = Object.entries(fragranceRecommendations).map(([impression, item]) => ({
      ...item,
      impressionMatch: impression === values.impression,
      score: (impression === values.impression ? 4 : 0) + (item.family === values.family ? 4 : 0)
        + 2 - Math.abs(fragrancePresence[item.intensity] - fragrancePresence[values.intensity])
    })).sort((a, b) => b.score - a.score || Number(b.impressionMatch) - Number(a.impressionMatch));
    return ranked[0];
  };
  const fragranceResultCopy = (recommendation, values, english) => {
    const copy = recommendation[english ? 'en' : 'fr'];
    if (recommendation.intensity === values.intensity) return copy;
    return copy + (english
      ? ' This fragrance best matches your scent preferences. Adjust the diffuser’s intensity to suit your desired presence.'
      : ' Ce parfum correspond le mieux à vos préférences olfactives. Ajustez l’intensité du diffuseur selon la présence souhaitée.');
  };
  fragranceForm?.addEventListener('submit', event => {
    event.preventDefault();
    const values = Object.fromEntries(new FormData(fragranceForm).entries());
    const recommendation = recommendFragrance(values);
    if (!recommendation) return;
    fragranceQuiz.querySelector('[data-quiz-title]').textContent = recommendation.name;
    fragranceQuiz.querySelector('[data-quiz-copy]').textContent = fragranceResultCopy(recommendation, values, locale.startsWith('en'));
    fragranceQuiz.querySelector('[data-quiz-link]').href = `${rootPath}products/${recommendation.handle}`;
    fragranceResult.hidden = false;
    fragranceResult.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });
  fragranceQuiz?.querySelector('[data-quiz-reset]')?.addEventListener('click', () => {
    fragranceForm.reset();
    fragranceStepper?.reset();
    fragranceResult.hidden = true;
  });

  const diffuserQuiz = document.querySelector('[data-diffuser-quiz]');
  const diffuserForm = diffuserQuiz?.querySelector('form');
  const diffuserResult = diffuserQuiz?.querySelector('[data-diffuser-result]');
  const diffuserStepper = setupQuizStepper(diffuserForm);
  // Capacities and names confirmed by the owner; pro is a legacy internal key.
  const diffuserRecommendations = {
    atelier: { key: 'atelier', name: 'ATELIER', handle: 'diffuseur-atelier', maxArea: 20 },
    signature: { key: 'signature', name: 'SIGNATURE', handle: 'diffuseur-signature', maxArea: 80 },
    pro: { key: 'pro', name: 'GALERIE', handle: 'diffuseur-galerie', maxArea: 300 }
  };
  const recommendDiffuser = values => {
    // Only Q1 determines the model. Q2/Q3 must never upgrade or downgrade it.
    if (!Object.hasOwn(diffuserRecommendations, values.surface)) return null;
    return diffuserRecommendations[values.surface];
  };
  const diffuserResultCopy = (recommendation, values, english) => english
    ? `Based on the surface area of your space, ${recommendation.name} is the most suitable format.`
    : `D’après la surface de votre espace, ${recommendation.name} est le format le plus adapté.`;
  diffuserForm?.addEventListener('submit', event => {
    event.preventDefault();
    const values = Object.fromEntries(new FormData(diffuserForm).entries());
    const recommendation = recommendDiffuser(values);
    if (!recommendation) return;
    diffuserQuiz.querySelector('[data-diffuser-copy]').textContent = diffuserResultCopy(recommendation, values, locale.startsWith('en'));
    diffuserQuiz.querySelector('[data-diffuser-link]').href = `${rootPath}products/${recommendation.handle}`;
    diffuserResult.hidden = false;
    diffuserResult.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });
  diffuserQuiz?.querySelector('[data-diffuser-reset]')?.addEventListener('click', () => {
    diffuserForm.reset();
    diffuserStepper?.reset();
    diffuserResult.hidden = true;
  });

  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      const item = question.closest('.faq-item');
      const isOpen = item.classList.toggle('is-open');
      question.setAttribute('aria-expanded', String(isOpen));
    });
  });

  const activeCurrency = window.Shopify?.currency?.active || 'EUR';
  const currencyLabel = { EUR: '€', CHF: 'CHF', USD: '$', GBP: '£', CAD: 'CAD', AUD: 'AUD' }[activeCurrency] || activeCurrency;
  const formatPrice = value => `${new Intl.NumberFormat(locale.startsWith('en') ? 'en-GB' : 'fr-FR', { maximumFractionDigits: 0 }).format(Number(value || 0))} ${currencyLabel}`;
  const diffuserChoices = {
    compact: { name: 'Diffuseur Atelier', price: 89 },
      maison: { name: 'Diffuseur Galerie', price: 299 },
    signature: { name: 'Diffuseur Signature', price: 179 }
  };
  const diffuserButton = document.querySelector('.product-purchase [data-add-product]:not([data-add-recharge])');
  const applyDiffuserChoice = input => {
    const choice = diffuserChoices[input?.value];
    if (!choice || !diffuserButton) return;
    diffuserButton.dataset.addProduct = choice.name;
    diffuserButton.dataset.price = String(choice.price);
    diffuserButton.textContent = `${tr('addToCart', 'Ajouter au panier')} · ${formatPrice(choice.price)}`;
    diffuserButton.disabled = false;
    const title = document.querySelector('[data-diffuser-title]');
    const price = document.querySelector('[data-diffuser-price]');
    if (title) title.textContent = choice.name;
    if (price) price.textContent = formatPrice(choice.price);
  };
  const diffuserInputs = [...document.querySelectorAll('input[name="rituel"]')];
  diffuserInputs.forEach(input => input.addEventListener('change', () => applyDiffuserChoice(input)));
  const requestedSize = new URLSearchParams(location.search).get('size');
  const initialDiffuser = diffuserInputs.find(input => input.value === requestedSize);
  if (initialDiffuser) { initialDiffuser.checked = true; applyDiffuserChoice(initialDiffuser); }

  const refillScents = {
    ladoree: ['Aura Dorée', 'Un sillage ambré, vanillé et sensuel, à la présence enveloppante.', 'parfum-ladoree.png'],
    'ombre-blanche': ['Ombre Blanche', 'Boisé · Musqué · Minéral', 'parfum-ombre-blanche.png'],
    'second-sens': ['Pourpre 15.21', 'Épicé · Boisé · Profond', 'parfum-velours-pourpre.png'],
    subteal: ['Volute de Thé', 'Parfum d’intérieur', 'volute-de-the-01.png'],
    'ambre-clair': ['Éclat de Nerola', 'Floral · Lumineux · Subtil', 'eclat-de-nerola-01.png']
  };
  const refillFormats = { '20': ['20 ml', 25], '50': ['50 ml', 60], '500': ['500 ml', 180] };
  const refillButton = document.querySelector('[data-add-recharge]');
  const refillImage = document.querySelector('[data-recharge-image]');
  const requestedScent = new URLSearchParams(location.search).get('parfum');
  const scentKey = refillScents[requestedScent] ? requestedScent : 'ladoree';
  const scent = refillScents[scentKey];
  const refillTitle = document.querySelector('[data-recharge-title]');
  const refillDescription = document.querySelector('[data-recharge-description]');
  if (refillTitle) refillTitle.textContent = scent[0];
  if (refillDescription) refillDescription.textContent = scent[1];
  if (refillImage && scent[2]) {
    refillImage.src = refillImage.src.replace(/parfum-ladoree\.png/, scent[2]);
    refillImage.alt = `${scent[0]}, ESCENTIEL`;
  }
  const applyRefillChoice = input => {
    const format = refillFormats[input?.value];
    if (!format || !refillButton) return;
    refillButton.dataset.addProduct = `${scent[0]} · ${format[0]}`;
    refillButton.dataset.price = String(format[1]);
    refillButton.textContent = `${tr('addToCart', 'Ajouter au panier')} · ${formatPrice(format[1])}`;
    refillButton.disabled = false;
    const price = document.querySelector('[data-recharge-price]');
    if (price) price.textContent = formatPrice(format[1]);
  };
  document.querySelectorAll('input[name="recharge-format"]').forEach(input => input.addEventListener('change', () => applyRefillChoice(input)));
  applyRefillChoice(document.querySelector('input[name="recharge-format"]:checked'));

  document.querySelectorAll('.product-purchase [data-add-product]').forEach(button => button.addEventListener('click', () => {
    if (button.disabled || !button.dataset.addProduct) return;
    button.textContent = tr('selectionSaved', 'Sélection enregistrée');
  }));

  document.querySelectorAll('[data-demo-form]').forEach(form => {
    form.addEventListener('submit', event => {
      event.preventDefault();
      const feedback = form.querySelector('[data-form-feedback]');
      if (feedback) feedback.textContent = tr('requestSaved', 'Votre demande a bien été enregistrée.');
      form.reset();
    });
  });

  const nativeSearchOpen = document.querySelector('[data-native-search-open]');
  const nativeSearchForm = document.querySelector('[data-native-search-form]');
  nativeSearchOpen?.addEventListener('click', () => {
    nativeSearchForm.hidden = false;
    nativeSearchOpen.hidden = true;
    nativeSearchForm.querySelector('input')?.focus();
  });

  document.querySelectorAll('[data-selling-plan-picker]').forEach(picker => {
    const value = picker.querySelector('[data-selling-plan-value]');
    picker.querySelectorAll('[data-selling-plan-choice]').forEach(choice => {
      choice.addEventListener('change', () => {
        if (value) value.value = choice.dataset.sellingPlanChoice === 'one-time' ? '' : choice.dataset.sellingPlanChoice;
      });
    });
  });

  const countryFlag = code => {
    const country = String(code || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(country)) return '';
    return [...country].map(character => String.fromCodePoint(127397 + character.charCodeAt(0))).join('');
  };
  document.querySelectorAll('[data-country-flag]').forEach(flag => {
    flag.textContent = countryFlag(flag.dataset.countryFlag);
  });

  const socialProof = document.querySelector('[data-social-proof]');
  const socialProofMessage = socialProof?.querySelector('[data-social-proof-message]');
  const socialProofTime = socialProof?.querySelector('[data-social-proof-time]');
  let socialProofTimer;
  const hideSocialProof = () => {
    socialProof?.classList.remove('is-visible');
    window.setTimeout(() => socialProof?.setAttribute('hidden', ''), 360);
  };
  const loadSocialProof = async () => {
    if (!socialProof?.dataset.endpoint || !socialProofMessage) return;
    try {
      const endpoint = new URL(socialProof.dataset.endpoint, window.location.origin);
      endpoint.searchParams.set('path', window.location.pathname);
      const response = await fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) return;
      const payload = await response.json();
      const viewers = Number(payload?.viewers);
      if (!Number.isFinite(viewers) || viewers < 1) return;
      const flags = Array.isArray(payload.countries)
        ? payload.countries.map(item => countryFlag(item.code || item.country_code || item)).filter(Boolean).slice(0, 5).join(' ')
        : countryFlag(payload.country_code);
      const locale = document.documentElement.lang || 'fr';
      const message = locale.startsWith('en')
        ? `${viewers} ${viewers === 1 ? 'person is' : 'people are'} viewing this page now.`
        : `${viewers} personne${viewers > 1 ? 's' : ''} regarde${viewers > 1 ? 'nt' : ''} actuellement cette page.`;
      socialProofMessage.textContent = `${flags ? `${flags} ` : ''}${message}`;
      if (socialProofTime) socialProofTime.textContent = locale.startsWith('en') ? 'Updated just now' : 'Mis à jour à l’instant';
      socialProof.removeAttribute('hidden');
      requestAnimationFrame(() => socialProof.classList.add('is-visible'));
      clearTimeout(socialProofTimer);
      socialProofTimer = setTimeout(hideSocialProof, 5200);
    } catch {
      // No verified presence data: keep the notification hidden.
    }
  };
  socialProof?.querySelector('[data-social-proof-close]')?.addEventListener('click', hideSocialProof);
  if (socialProof && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setTimeout(loadSocialProof, 4500);
    setInterval(loadSocialProof, 30000);
  }

  const nativeProductForm = document.querySelector('.product-purchase .product-form');
  const nativeAddButton = nativeProductForm?.querySelector('button[type="submit"][name="add"]');
  const nativeVariantId = nativeProductForm?.querySelector('[data-product-variant-id]');
  const nativeVariantRadios = [...(nativeProductForm?.querySelectorAll('[data-product-variant-radio]') || [])];
  const syncNativeVariant = radio => {
    if (!radio || !nativeVariantId || !nativeAddButton) return;
    nativeVariantId.value = radio.value;
    const available = radio.dataset.available === 'true';
    nativeAddButton.disabled = !available;
    nativeAddButton.textContent = available ? `${tr('addToCart', 'Ajouter au panier')} · ${radio.dataset.price}` : tr('soldOut', 'Épuisé');
  };
  nativeVariantRadios.forEach(radio => radio.addEventListener('change', () => syncNativeVariant(radio)));
  syncNativeVariant(nativeVariantRadios.find(radio => radio.checked));
  const nativePurchase = nativeAddButton?.closest('.product-purchase');
  if (nativeAddButton && nativePurchase && !document.querySelector('.product-sticky-add')) {
    const sticky = document.createElement('aside');
    sticky.className = 'product-sticky-add';
    sticky.setAttribute('aria-label', tr('addProduct', 'Ajouter le produit au panier'));
    sticky.innerHTML = `<div class="product-sticky-add__label"><span class="product-sticky-add__eyebrow">${tr('selection', 'Votre sélection')}</span><strong class="product-sticky-add__product"></strong></div><button class="button dark product-sticky-add__button" type="button"></button>`;
    document.body.appendChild(sticky);
    const stickyLabel = sticky.querySelector('.product-sticky-add__product');
    const stickyButton = sticky.querySelector('.product-sticky-add__button');
    const syncSticky = () => {
      const title = nativePurchase.querySelector('h1')?.textContent?.trim() || 'Produit ESCENTIEL';
      const selected = nativePurchase.querySelector('[data-product-variant-radio]:checked')?.closest('label')?.querySelector('b')?.textContent?.trim()
        || nativePurchase.querySelector('select[name="id"] option:checked')?.textContent?.trim();
      stickyLabel.textContent = `${title}${selected ? ` · ${selected}` : ''}`;
      stickyButton.textContent = nativeAddButton.textContent.trim() || tr('addToCart', 'Ajouter au panier');
      stickyButton.disabled = nativeAddButton.disabled;
    };
    syncSticky();
    nativePurchase.querySelectorAll('select, input').forEach(input => input.addEventListener('change', syncSticky));
    new MutationObserver(syncSticky).observe(nativePurchase, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    stickyButton.addEventListener('click', () => { if (!nativeAddButton.disabled) nativeAddButton.click(); });
    const updateStickyVisibility = () => {
      const rect = nativeAddButton.getBoundingClientRect();
      const headerBottom = document.querySelector('header')?.getBoundingClientRect().bottom || 0;
      const outsideViewport = rect.bottom <= headerBottom || rect.top >= window.innerHeight;
      sticky.classList.toggle('is-visible', outsideViewport && window.scrollY > 12);
    };
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    updateStickyVisibility();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-express-checkout]');
    if (!trigger) return;
    event.preventDefault();
    const wrapper = trigger.closest('.product-accelerated-checkout');
    const form = wrapper?.closest('form');
    const native = wrapper?.querySelector('shopify-accelerated-checkout');
    const hiddenVariant = form?.querySelector('input[name="id"]')?.value;
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    let nativeVariants = [];
    try { nativeVariants = JSON.parse(native?.getAttribute('variant-params') || '[]'); } catch (error) { nativeVariants = []; }
    const variantId = hiddenVariant || urlVariant || nativeVariants[0]?.id;
    const quantity = Math.max(1, Number(form?.querySelector('input[name="quantity"]')?.value || 1));
    if (!variantId) return;
    window.location.assign(`${window.Shopify?.routes?.root || '/'}cart/${variantId}:${quantity}?checkout`);
  });

  // Ajout rapide depuis les cartes : les variantes viennent du produit Shopify réel.
  const quickDrawer = document.querySelector('[data-quick-add-drawer]');
  const quickBackdrop = document.querySelector('.quick-add-backdrop');
  const quickTitle = quickDrawer?.querySelector('[data-quick-add-title]');
    const quickOptions = quickDrawer?.querySelector('[data-quick-add-options]');
    const quickSubmit = quickDrawer?.querySelector('[data-quick-add-submit]');
    const quickCheckout = quickDrawer?.querySelector('[data-quick-add-checkout]');
    const quickTotal = quickDrawer?.querySelector('[data-quick-add-total]');
  let quickSelectedItems = [];
  let quickIsDiffuser = false;
  let quickRefillItem = null;
  let quickDiffuserVariant = null;
  let quickDiffuserQuantity = 1;
  const quickClose = () => {
    quickDrawer?.classList.remove('is-open');
    quickBackdrop?.classList.remove('is-open');
    quickDrawer?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    quickSelectedItems = [];
    quickIsDiffuser = false;
    quickRefillItem = null;
    quickDiffuserVariant = null;
    quickDiffuserQuantity = 1;
    if (quickTotal) quickTotal.textContent = '—';
      if (quickSubmit) { quickSubmit.disabled = true; quickSubmit.textContent = tr('addToCart', 'Ajouter au panier'); }
      if (quickCheckout) quickCheckout.disabled = true;
  };
  const quickMoney = cents => formatPrice(Number(cents || 0) / 100);
  const priceToCents = value => {
    const numeric = Number(value || 0);
    return numeric < 1000 ? Math.round(numeric * 100) : Math.round(numeric);
  };
  const updateQuickSubmit = () => {
    if (!quickSubmit) return;
    const total = quickSelectedItems.reduce((sum, item) => sum + (Number(item.price || 0) * Number(item.quantity || 1)), 0);
      quickSubmit.disabled = !quickSelectedItems.length;
      if (quickCheckout) quickCheckout.disabled = !quickSelectedItems.length;
      quickSubmit.textContent = `${tr('addToCart', 'Ajouter au panier')} · ${quickMoney(total)}`;
    if (quickTotal) quickTotal.textContent = quickMoney(total);
  };
  const refreshCartBadge = async () => {
    try {
      const cart = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } }).then(response => response.json());
      const cartLink = document.querySelector('.cart-link');
      if (!cartLink) return;
      let badge = cartLink.querySelector('span');
      if (!badge) { badge = document.createElement('span'); cartLink.append(badge); }
      badge.textContent = cart.item_count;
      badge.hidden = !cart.item_count;
    } catch { /* Le panier Shopify reste la source de vérité. */ }
  };
  const quickFormatLabel = title => {
    const normalized = String(title || '').toLowerCase();
    if (normalized.includes('20')) return 'Pour Atelier';
    if (normalized.includes('50')) return 'Pour Signature';
    if (normalized.includes('500')) return 'Pour Galerie';
    return tr('available', 'Disponible');
  };
  const renderQuickVariant = variant => `<button type="button" data-quick-variant="${variant.id}" data-quick-price="${variant.price}"${variant.available ? '' : ' disabled'}><span>${variant.title}<small>${variant.available ? quickFormatLabel(variant.title) : tr('soldOut', 'Épuisé')}</small></span><strong>${quickMoney(variant.price)}</strong></button>`;
  const quickPlainText = value => String(value || '').replace(/<(style|script)\b[^>]*>[\s\S]*?<\/\1>/gi, ' ').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
  const quickImageUrl = image => typeof image === 'string' ? image : (image?.src || image?.url || '');
  const quickEscape = value => String(value || '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
  const quickSyncDiffuserItems = () => {
    quickSelectedItems = quickDiffuserVariant ? [{ id: Number(quickDiffuserVariant.id), price: Number(quickDiffuserVariant.price), quantity: quickDiffuserQuantity }, ...(quickRefillItem ? [{ ...quickRefillItem, quantity: 1 }] : [])] : [];
    updateQuickSubmit();
  };
  const setQuickSelection = (items, button) => {
    quickOptions.querySelectorAll('[data-quick-variant]').forEach(option => option.classList.remove('is-selected'));
    button?.classList.add('is-selected');
    quickSelectedItems = items;
    updateQuickSubmit();
  };
  const openQuickDrawer = async (handle, type, quantity = 1, requestedRefillFormat = '', requestedVariantId = '') => {
    if (!quickDrawer || !quickOptions || !handle) return;
    quickTitle.textContent = '…';
    quickOptions.innerHTML = `<p class="muted">${tr('loading', 'Chargement des formats…')}</p>`;
    quickSelectedItems = [];
    quickIsDiffuser = type === 'Diffuseur';
    quickRefillItem = null;
    quickDiffuserVariant = null;
    quickDiffuserQuantity = Math.max(1, Number(quantity) || 1);
    if (quickSubmit) { quickSubmit.disabled = true; quickSubmit.textContent = tr('addToCart', 'Ajouter au panier'); }
    if (quickCheckout) quickCheckout.disabled = true;
    quickDrawer.classList.add('is-open');
    quickBackdrop?.classList.add('is-open');
    quickDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    try {
      const product = await fetch(`${rootPath}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } }).then(response => {
        if (!response.ok) throw new Error('product');
        return response.json();
      });
      quickTitle.textContent = product.title;
      if (quickIsDiffuser) {
        const compatibleFormat = requestedRefillFormat;
        const diffuserVariant = product.variants.find(variant => String(variant.id) === String(requestedVariantId) && variant.available)
          || product.variants.find(variant => variant.available)
          || product.variants[0];
        const refillData = await fetch(`${rootPath}collections/recharges/products.json?limit=50`, { headers: { Accept: 'application/json' } }).then(response => {
          if (!response.ok) throw new Error('refills');
          return response.json();
        });
        const refills = compatibleFormat ? (refillData.products || []).map(refill => ({
          title: refill.title,
          image: quickImageUrl(refill.images?.[0] || refill.image || refill.featured_image),
          description: quickPlainText(refill.body_html).slice(0, 92),
          variant: refill.variants.find(variant => variant.title.toLowerCase() === compatibleFormat.toLowerCase())
        })).filter(refill => refill.variant).map(refill => ({
          title: refill.title,
          image: refill.image,
          description: refill.description,
          variant: { ...refill.variant, price: priceToCents(refill.variant.price) }
        })) : [];
        quickDiffuserVariant = diffuserVariant ? { ...diffuserVariant, price: priceToCents(diffuserVariant.price) } : null;
        const availableRefills = refills.filter(refill => refill.variant.available);
        const diffuserImage = quickImageUrl(product.featured_image || product.images?.[0]);
        const summaryImage = diffuserImage ? `<img src="${quickEscape(diffuserImage)}" alt="${quickEscape(product.title)}">` : '<div class="quick-add-summary__placeholder"></div>';
        quickOptions.innerHTML = `<div class="quick-add-summary">${summaryImage}<div class="quick-add-summary__content"><strong>${quickEscape(product.title)}</strong><span>${tr('diffuser', 'Diffuseur')}</span><b>${quickMoney(quickDiffuserVariant?.price)}</b><div class="quick-add-quantity" aria-label="${tr('quantity', 'Quantité')}"><button type="button" data-quick-quantity="decrease" aria-label="${tr('decrease', 'Diminuer')}">−</button><b data-quick-quantity-value>${quickDiffuserQuantity}</b><button type="button" data-quick-quantity="increase" aria-label="${tr('increase', 'Augmenter')}">+</button></div></div></div><div class="quick-add-refills"><p class="quick-add-drawer__hint">${tr('chooseFragrance', 'Choisissez son parfum')}</p><p class="quick-add-refills__subheading">${tr('compatibleRefill', 'Recharge compatible')} · ${quickEscape(compatibleFormat)}</p>${availableRefills.length ? availableRefills.map(refill => `<article class="quick-add-refill-card"><div class="quick-add-refill-card__media">${refill.image ? `<img src="${quickEscape(refill.image)}" alt="${quickEscape(refill.title)}">` : ''}</div><div class="quick-add-refill-card__body"><strong>${quickEscape(refill.title)}</strong><p>${quickEscape(refill.description || tr('fallbackFragrance', 'Une fragrance ESCENTIEL à associer à votre diffuseur.'))}</p><b>${quickMoney(refill.variant.price)}</b></div><button type="button" class="quick-add-refill-card__button" data-quick-refill-id="${refill.variant.id}" aria-pressed="false">${tr('addToCart', 'Ajouter')}</button></article>`).join('') : `<p class="muted">${tr('noneAvailable', 'Aucune recharge compatible disponible.')}</p>`}</div>`;
        quickOptions.querySelectorAll('[data-quick-refill-id]').forEach(button => button.addEventListener('click', () => {
          const selected = availableRefills.find(refill => String(refill.variant.id) === button.dataset.quickRefillId);
          if (!selected) return;
          const alreadySelected = quickRefillItem?.id === Number(selected.variant.id);
          quickRefillItem = alreadySelected ? null : { id: Number(selected.variant.id), price: selected.variant.price, title: selected.title };
          quickOptions.querySelectorAll('.quick-add-refill-card').forEach(card => {
            const cardButton = card.querySelector('[data-quick-refill-id]');
            const isSelected = cardButton?.dataset.quickRefillId === String(quickRefillItem?.id || '');
            card.classList.toggle('is-selected', isSelected);
            if (cardButton) {
              cardButton.textContent = isSelected ? tr('added', 'Ajouté') : tr('addToCart', 'Ajouter');
              cardButton.setAttribute('aria-pressed', String(isSelected));
            }
          });
          quickSyncDiffuserItems();
        }));
        quickOptions.querySelectorAll('[data-quick-quantity]').forEach(button => button.addEventListener('click', () => {
          quickDiffuserQuantity = Math.max(1, quickDiffuserQuantity + (button.dataset.quickQuantity === 'increase' ? 1 : -1));
          const value = quickOptions.querySelector('[data-quick-quantity-value]');
          if (value) value.textContent = quickDiffuserQuantity;
          quickSyncDiffuserItems();
        }));
        quickSyncDiffuserItems();
      } else {
        quickOptions.innerHTML = product.variants.map(renderQuickVariant).join('');
        quickOptions.querySelectorAll('[data-quick-variant]').forEach(button => button.addEventListener('click', () => setQuickSelection([{ id: Number(button.dataset.quickVariant), price: button.dataset.quickPrice }], button)));
        const defaultVariant = product.variants.find(variant => variant.available) || product.variants[0];
        const defaultButton = defaultVariant && quickOptions.querySelector(`[data-quick-variant="${defaultVariant.id}"]`);
        if (defaultButton) defaultButton.click();
      }
    } catch {
      quickOptions.innerHTML = `<p class="muted">${tr('unavailable', 'Les variantes sont temporairement indisponibles.')}</p>`;
    }
  };
    const submitQuickAdd = async (redirectToCheckout = false) => {
      if (!quickSelectedItems.length) return;
      quickSubmit.disabled = true;
      if (quickCheckout) quickCheckout.disabled = true;
      quickSubmit.textContent = tr('adding', 'Ajout en cours…');
    try {
      const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: quickSelectedItems.map(item => ({ id: item.id, quantity: Number(item.quantity || 1) })) }) });
        if (!response.ok) throw new Error('cart');
        await refreshCartBadge();
        if (redirectToCheckout) {
          window.location.assign(`${rootPath}checkout`);
          return;
        }
        quickSubmit.textContent = tr('addedToCart', 'Ajouté au panier');
        window.setTimeout(quickClose, 500);
      } catch {
        quickSubmit.disabled = false;
        if (quickCheckout) quickCheckout.disabled = false;
        quickSubmit.textContent = tr('retry', 'Réessayer');
      }
    };

    quickSubmit?.addEventListener('click', () => submitQuickAdd(false));
    quickCheckout?.addEventListener('click', () => submitQuickAdd(true));
  document.querySelectorAll('[data-quick-add]').forEach(button => button.addEventListener('click', () => openQuickDrawer(button.dataset.productHandle, button.dataset.productType, 1, button.dataset.refillFormat || '')));
  const diffuserProduct = document.querySelector('[data-diffuser-product][data-product-type="Diffuseur"], .product-detail[data-product-type="Diffuseur"]');
  const diffuserProductForm = diffuserProduct?.querySelector('.product-form');
  diffuserProductForm?.addEventListener('submit', event => {
    if (event.submitter?.classList.contains('product-express-payment')) return;
    event.preventDefault();
    const quantity = diffuserProductForm.querySelector('[name="quantity"]')?.value || 1;
    const variantId = diffuserProductForm.querySelector('[name="id"]')?.value || '';
    openQuickDrawer(diffuserProduct.dataset.productHandle, 'Diffuseur', quantity, diffuserProduct.dataset.refillFormat || '', variantId);
  });
  quickBackdrop?.addEventListener('click', quickClose);
  quickDrawer?.querySelectorAll('[data-quick-add-close]').forEach(button => button.addEventListener('click', quickClose));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') quickClose(); });
})();
